import { useCallback, useEffect, useState } from "react";
import { Bot } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Panel, Tag } from "@/components/common";

export const ModeSwitch = ({ onChange }) => {
  const [s, setS] = useState(null);
  const load = useCallback(() => api.get("/settings/autopilot").then((r) => setS(r.data)), []);
  useEffect(() => { load(); }, [load]);
  const set = async (mode) => {
    if (mode === "autopilot" && !window.confirm("Switch to Autopilot? The AI will auto-execute LOW and MEDIUM risk proposals within your guardrails. HIGH risk always waits for you.")) return;
    try { await api.put("/settings/autopilot", { mode }); toast.success(mode === "autopilot" ? "Autopilot ON" : "Approve mode"); load(); onChange?.(); } catch (e) { toast.error(errMsg(e)); }
  };
  if (!s) return null;
  return (
    <Panel title="Mode" icon={Bot} testid="mode-panel" right={<Tag tone={s.mode === "autopilot" ? "amber" : "cyan"} testid="mode-status">{s.mode === "autopilot" ? "Autopilot" : "Approve"}</Tag>}>
      <div className="mb-3 grid grid-cols-2 gap-2">
        {["approve", "autopilot"].map((m) => (
          <button key={m} data-testid={`mode-${m}-button`} onClick={() => s.mode !== m && set(m)} className={`cc-btn px-3 py-2 text-xs ${s.mode === m ? "cc-btn-primary" : "cc-btn-ghost"}`}>{m === "approve" ? "Approve" : "Autopilot"}</button>
        ))}
      </div>
      <p className="text-xs text-slate-400">{s.mode === "autopilot" ? "LOW and MEDIUM risk optimiser proposals run automatically (dry run first, logged as Auto, undoable). HIGH risk (new campaigns, budget increases, enabling campaigns) waits for you." : "Nothing changes in Google Ads until you approve it."}</p>
      {s.mode === "autopilot" && !s.execution_enabled && <p className="mt-2 text-xs text-amber-300" data-testid="mode-exec-off-warning">Live execution is OFF, so Autopilot can't act yet.</p>}
    </Panel>
  );
};
